import React from 'react'
import './App.css'
import 'antd/dist/antd.css'
import { Router, Route } from 'react-router'
import PageRegister from './pages/PageRegister'
import PageAdmin from './pages/PageAdmin'
const App = props => {
  return (
    <Router {...props}>
      <Route path="/" component={PageRegister} />
      <Route path="/adminManagement" component={PageAdmin} />
    </Router>
  )
}

export default App
